import React, {Fragment, useEffect, useRef, useState} from 'react';
import {Column} from 'primereact/column';
import {ColumnGroup} from 'primereact/columngroup';
import {Row} from 'primereact/row';
import {sendRequest, UrlGenerator} from '../../../utils/request';
import GridFilter from './GridFilter';
import {set, get} from '../../../utils/dotutils';
import isEqual from 'lodash-es/isEqual';
import {getComponentConfig, loadComponent} from "../../../utils/components";
import classNames from "classnames";
import EditorField from "./EditorField";
import SelectorGridPreFilters from "./SelectorGridPreFilters";
import config from "../../../config/config";
import axios from "axios";
import {connectAdvanced} from "src/store";
import {bindActionCreators} from "redux";
import {setSelectorGridState} from "../../../actions";
import { store } from "src/store";
import PropTypes from "prop-types";
import SelectorTable from "./SelectorTable";
import {paramsSerializer, postData} from "../../../utils/request";
import Select from "../Select";
import Icon from "../Icon";
import Button from "../Button";
import ComponentConfig from "../ComponentConfig";
import PropsProxy from "../../layout/PropsProxy";
import Modal from "../../layout/Modal";
import Portal from "../../layout/Portal";
import SearchField from "./SearchField";
import debounce from 'lodash-es/debounce';
import TextInput from "../TextInput";
import {ifCompletedInput} from "../../../utils/other";
import Excel from "./Export/Excel";
import {list} from "../../../utils/array";
import Confirm from "../Confirm";
import CheckBox from "../CheckBox";
import Tooltip from "../../../utils/Tooltip";
import Import from "./DataGrids/Imports/Import";
import {default as DataGridTableActions} from "./DataGrids/Table/Actions";

const placeHolderComponent = (props) => {
    if (props.type && props.type.placeHolder) {
        return <props.type.placeHolder {...props} />;
    }
    return (
        <div className="ph-item ph-table">
            <div className="ph-col-12">
                <div className="ph-row ph-head">
                    {[0, 0].map((i, idx) => <div key={idx} className="ph-col-2 ph-cell"/>)}
                </div>
                <div className="ph-row ph-head">
                    {[0, 0, 0, 0, 0, 0].map((i, idx) => <div key={idx} className="ph-col-2 ph-cell"/>)}
                </div>
                {[0, 0, 0].map((i, idx) => <div key={idx} className="ph-row">
                    {[0, 0, 0, 0, 0, 0].map((i, idx) => <div key={idx} className="ph-col-2 ph-cell"/>)}
                </div>)}
                <div className="ph-row ph-foot">
                    <div className="ph-col-12 ph-cell"/>
                </div>
            </div>
        </div>
    );
};

const Actions = (propsTop) => {
    if (!propsTop.props.componentListFieldConfig) {
        return null;
    }
    return <Fragment>
        {propsTop.item[propsTop.props.componentListFieldConfig.idfield] ? <Confirm
            icon={{lib: "fa", name: "trash"}}
            color="danger"
            buttonSize="xs"
            header="Törlés"
            body="Biztosan törlöd ezt a tételt?"
            acceptButton="Törlés"
            tooltip="Törlés"
            timeout={3}
            disabled={propsTop.props.disabled || propsTop.props.loading}
            onAccept={async (e) => {
                e && e.preventDefault();
                await propsTop.onItemRemove(propsTop.item);
            }}
        /> : <Button
            size="xs"
            color="primary"
            tooltip="Mentés"
            icon={{lib: "fa", name: "save"}}
            disabled={propsTop.props.disabled || propsTop.props.loading}
            onClick={async (e) => {
                e && e.preventDefault();
                await propsTop.addNewRow(propsTop.item);
            }}
        />}
    </Fragment>;
}

const ModalAdd = (props) => {
    let selectorList = useRef();
    let selectionRequest;
    if (!props.componentListFieldConfig) {
        return null;
    }
    const [opened, setOpened] = useState(false);
    const [filtered, setFiltered] = useState(false);
    const [selection, setSelection] = useState(props.selection);
    useEffect(() => {
        if (props.disabled || props.loading) {
            setOpened(false);
        }
    }, [props.disabled, props.loading]);
    useEffect(() => {
        setSelection(props.selection);
    }, [props.selection]);
    const parentid = (props.data && props.data[props.componentConfig.idfield]) || props.parentid;
    useEffect(() => {
        selectionRequest && selectionRequest.abort();
        if (props.selection) return;
        const params = {
            option: "componentlist",
            parentcomponent: props.componentConfig.componentname,
            getcolumns: true,
            withheader: true,
            listfield: props.name,
            parentid: parentid,
            itemsperpage: 1,
            view: [props.componentListFieldConfig.idfield],
            aggregations: {
                fields: {
                    [props.componentListFieldConfig.idfield]: {
                        type: "GROUP_CONCAT"
                    }
                }
            }
        };
        selectionRequest = sendRequest(params);
        selectionRequest.then((response) => {
            setSelection((get(response, "aggregations.0." + props.componentListFieldConfig.idfield) || "").split(",").filter(Boolean));
        });
    }, [props.componentListFieldConfig.componentname, parentid, props.selection]);
    const columns = {
        actions: {
            header: ' ',
            width: 'cell-button',
            renderer: (value, rowData) => {
                const checked = !!selection.find((s) => s + "" === "" + rowData[props.componentListFieldConfig.idfield]);
                return <CheckBox
                    value={1}
                    checked={checked}
                    label={false}
                    saveChanges={async () => {
                        if (!checked) {
                            await props.addNewRows([{[props.componentListFieldConfig.idfield]: rowData[props.componentListFieldConfig.idfield]}]);
                        } else {
                            await props.onItemRemove(rowData);
                        }
                    }}
                    disabled={props.disabled || props.isLoading}
                />;
            }
        },
        ...props.columns
    };
    return <Fragment>
        <Button
            className={classNames("listfield-add btn-xs", {disabled: props.disabled || props.loading})}
            color="default" icon={{lib: "fa", name: "plus"}}
            onClick={(e) => {
                e && e.preventDefault();
                if (props.disabled || props.loading) return;
                setOpened(true);
            }}
        />
        {opened && <Portal>
            <Modal
                size="large"
                state={opened}
                header="Kiválasztás"
                buttons={[
                    {
                        text: 'Bezárás',
                        props: {color: "default", disabled: props.disabled || props.isLoading},
                        onClose: true,
                        onClick: async () => {
                            try {
                                setOpened(false);
                            } catch (e) {

                            }
                        }
                    }
                ]}
            >
                <SelectorGrid
                    ref={selectorList}
                    view={[props.componentListFieldConfig.idfield]}
                    component={props.componentListFieldConfig.componentname}
                    selection={[]}
                    columns={columns}
                    filter={filtered ? (props.selectionFilter || {field: props.componentListFieldConfig.idfield, value: selection.length ? selection : [-1], operator: "in"}) : undefined}
                    paginatorRight={(frops) => {
                        return <Tooltip title={!filtered ? "Csak a kiválasztottakat mutasd" : "Mindent mutat"}>
                            <CheckBox
                                onIcon={{lib: "fa", name: "box"}}
                                offIcon={{lib: "fa", name: "box-open"}}
                                value={1}
                                checked={filtered}
                                label={false}
                                saveChanges={(field, value) => {
                                    setFiltered(!!value);
                                }}
                                {...frops}
                                disabled={frops.disabled || frops.isLoading}
                            />
                        </Tooltip>
                    }}
                />
            </Modal>
        </Portal>}
    </Fragment>
}

class DefaultSelectorGrid extends React.Component {

    static placeHolder = placeHolderComponent;

    static propTypes = {
        /**
         * Egy react komponens amit/amivel megjeleníti az adatokat
         * type React Component SelectorTable|SelectorImage|SelectorDocument
         */
        type: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
        /**
         * oszlop definiciók
         * header oszlop megnevezése
         * filterable szürhető-e az oszlop
         * sortable sorrendezhető az oszlop
         * className
         * renderer megjelenítés function (value, rowData)
         * editor ha az oszlop adatai szerkeszthetők egy dupla function (parent) => (props, value) =>
         * width: az oszlop szélessége 12/x
         */
        columns: PropTypes.object,
        /**
         * Alapértelmezett látható oszlopok
         */
        visibleColumns: PropTypes.array,
        /**
         * kiválasztott sorok json formában
         */
        selection: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func, PropTypes.string, PropTypes.number]),
        /**
         * egy vagy több sort lehet egyszerre kiválasztani
         */
        selectionMode: PropTypes.oneOf(["none", "single", "multiple"]),
        loading: PropTypes.bool,
        disabled: PropTypes.bool,
        /**
         * Későbbiekben lesz
         */
        virtualScroll: PropTypes.bool,
        /**
         * Ha egy komponens gyerekét akarjuk listázni, mondjuk egy purchase és annak a purchaseitem-jeit akkor a name="items" ami a purchase->items field-jét jelenti
         */
        name: PropTypes.string,
        /**
         * A lista elemein action hajtható végre (törlés, hozzáadás)
         */
        itemActions: PropTypes.bool,
        /**
         * aktuális lista mérete lapozás esetén
         */
        pageSize: PropTypes.number,
        /**
         * a komponens view-ja vagy egy string mondjuk "default", vagy tömb ["id","name"] vagy json {"partner": {"name": ""}}
         */
        view: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        /**
         * Vagy component vagy componentConfig ez a listázott komponens neve vagy configja.
         * kivétel ha egy komponens gyerekeit listázzuk akkor a szülő komponens config-ja vagy neve
         */
        component: PropTypes.string,
        option: PropTypes.string,
        componentConfig: PropTypes.object,
        /**
         * redux id ha a lista beállításait menteni akarjuk
         */
        gridid: PropTypes.string,
        /**
         * ez megegyezik a name beállítással annyi hogy itt lehet törölni és hozzáadni.
         */
        listfield: PropTypes.string,
        /**
         * a hozzáadás egy select akkor megtudjuk mondani milyen mező az amit a select-be látni kell
         */
        listfieldlabel: PropTypes.string,
        /**
         * Ha esetleg a hozzáadandó komponenst szeretnénk változtatni pl purchaseitem-ekhez product-ot szeretnénk hozzáadni akkor azt itt meg lehet tenni.
         */
        listfieldtype: PropTypes.string,
        /**
         * Előre meghatározott repo filtert lehet beadni
         */
        filter: PropTypes.any,
        /**
         * Parametereket lehet hozzáadni
         */
        parameters: PropTypes.any,
        /**
         * callback ha egy lista elem módosítva lett
         */
        onItemUpdate: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
        /**
         * callback ha egy lista elem törölve lett
         */
        onItemRemove: PropTypes.func,
        /**
         * Az adatok betöltése végén meghívott funkció
         */
        onLoadCompleted: PropTypes.func,
        /**
         * Az adatok betöltése előtt meghívott funkció
         */
        beforeLoad: PropTypes.func,
        /**
         * Ha változik a kiválaszott elemek "listája"
         */
        onSelectionChange: PropTypes.func,
        /**
         * callback Ha lapozunk
         */
        onPage: PropTypes.func,
        /**
         * Ez majd később
         */
        onVirtualScroll: PropTypes.func,
        /**
         * A lista milyen exportokat tud, pl.: Excel: [{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}]
         */
        exports: PropTypes.array,
        /**
         * Az oszlopok mérete állítható
         */
        resizableColumns: PropTypes.bool,
        /**
         * majd később
         */
        virtualRowHeight: PropTypes.number,
        /**
         * majd később
         */
        scrollHeight: PropTypes.number,
        /**
         * aggregációk, pl.:
         * {
         *      fields: {
         *          "count": {
         *              field: "pickedqty", type: "COUNT"
         *          },
         *          "pickedqty": {
         *              field: "pickedqty", type: "SUM"
         *          },
         *      }
         *  }
         */
        aggregations: PropTypes.object,
        /**
         * Az aggregációs sorok láthatóak
         */
        aggregationsVisible: PropTypes.bool,
        /**
         * ha a columns-ban beadott oszlopoknak más sorrendje van mint ahogy az fel van sorolva benne.
         */
        columnSort: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
        /**
         * Ha egyéb a rendszeren kívüli paramétereket kell küldeni a request-ben akkor azt itt lehet megtenni
         */
        reqparams: PropTypes.any,
        /**
         * sorok adataink formázására való
         */
        formatRows: PropTypes.func,
        /**
         * Egy lista a columns nevekből amelyeket ezzel a funkcióval egy select-ben a lista alatt jelenítünk meg és így ki/be lehet őket kapcsolni.
         */
        showVisibleColumnFilter: PropTypes.bool,
        /**
         * vagy a data vagy a parentid kell ha egy komponens gyerek field-ét szeretnénk listázni
         */
        data: PropTypes.any,
        /**
         * ha nem backend-es listát szeretnénk megjeleníteni hanem frontend-eset
         */
        value: PropTypes.any,
        /**
         * vagy a data vagy a parentid kell ha egy komponens gyerek field-ét szeretnénk listázni
         */
        parentid: PropTypes.any,
        /**
         * A lista lapozójának jobb oldalához adhatunk hozzá plusz komponenseket
         */
        paginatorRight: PropTypes.any,
        /**
         * A lista sorrendezése utáni callback
         */
        onRowReorder: PropTypes.func,
        /**
         * A backendes sorrendezést tartalmazó oszlop neve
         */
        rowReOrderBy: PropTypes.string,
        /**
         * a lista felett a komponenshez tartozó sűröket lehet be/ki kapcsolni
         */
        namedFilters: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.array]),
        /**
         * Üres lista üzenet
         */
        emptyMessage: PropTypes.string,
        /**
         * Betöltés üzenet
         */
        loadingMessage: PropTypes.string,
        actions: PropTypes.bool,
        /**
         * pl.: [5,10,15,20]
         */
        pageSizes: PropTypes.array,
        /**
         * true|false|Component|none
         */
        addButton: PropTypes.any,
        addRow: PropTypes.any,
        addRowFunction: PropTypes.func,
        addRowCollapse: PropTypes.any,
        rowClassName: PropTypes.any,
        className: PropTypes.any,
        onAddRows: PropTypes.func,
        addRowProps: PropTypes.any,
        groupBy: PropTypes.any,
        /**
         * alapértelmezett sorrend megadása
         */
        orderBy: PropTypes.any,
        /**
         * Elsődleges sorrend hozzáadása, pl ha név szerint rendezzük az orderBy-al akkor érdemes egy sortBy id-t betenni hogy ne "csúszkáljon" a lista
         */
        sortBy: PropTypes.any,
        /**
         * Frontend-es sorrendezés esetén callback
         */
        onSort: PropTypes.func,
        onRowDoubleClick: PropTypes.func,
        /**
         * Ha keresést adunk ki akkor az melyik keresési "típust" kell hogy használja
         */
        searchtype: PropTypes.string,
        /**
         * searchfield a lista jobb oldalán jelenik meg egy globális kereső amivel tudunk keresni
         */
        searchfield: PropTypes.bool,
        /**
         * sorrendezhető a lista, ez nem a front-end hanem ha backend-en van egy sorrend oszlop akkor azt tudjuk vele szabályozni
         */
        isOrderAble: PropTypes.bool,
        rowGroupMode: PropTypes.oneOf(["subheader", "rowspan"]),
        groupField: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.number]),
        rowGroupHeaderTemplate: PropTypes.func,
        rowGroupFooterTemplate: PropTypes.func,
    }

    constructor(props) {
        super(props);
        let order = props.orderBy || [];
        let sortField = null;
        let sortOrder = null;
        if (Array.isArray(order)) {
            if (order.length) {
                sortField = order[0].field;
                sortOrder = order[0].direction.toUpperCase() === 'DESC' ? -1 : 1;
            }
        } else if (order instanceof Object) {
            sortField = order.field;
            sortOrder = order.direction.toUpperCase() === 'DESC' ? -1 : 1;
        }
        const stored = props.gridid ? store.getState().selectorgrids[props.gridid] : null;
        const propsVisibleColumns = Object.keys(props.columns || {}).filter((column) => props.columns[column].visible !== false && props.columns[column].hidden !== true);
        const visibleColumns = props.visibleColumns || (propsVisibleColumns.length ? propsVisibleColumns : null) || Object.keys(props.columns || {});
        this.state = (stored && {...stored}) || {
            visibleColumns,
            paging: {first: 0, rows: this.props.pageSize === 0 ? 0 : (this.props.pageSize || 10)},
            view: this.props.view || null,
            loading: true,
            editor: {rowIndex: null, column: null},
            data: {
                rows: [],
                cols: [],
                aggregations: [],
                groupAggregations: []
            },
            emptyMessage: this.props.virtualScroll ? "" : (this.props.loadingMessage !== undefined && this.props.loadingMessage !== null ? this.props.loading : "Betöltés kérem várjon..."),
            filters: [],
            preFilters: {},
            search: null,
            columns: [],
            group: props.groupBy || [],
            order: props.orderBy || [],
            sort: props.sortBy || [],
            sortField,
            sortOrder
        };

        this.state.preFilters = this.state.preFilters || {};
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    setPersistenceState = (state, cb) => {
        this.setState(state, () => {
            if (this.props.gridid) {
                this.props.setSelectorGridState(this.props.gridid, this.state);
            }
            cb && cb();
        });
    }

    componentWillUnmount() {
        this.lastrequest && this.lastrequest.abort();
        this.prefilterRequest && this.prefilterRequest.abort();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        /*let check = JSON.parse(JSON.stringify(prevProps));
        delete check.selection;
        let checkNext = JSON.parse(JSON.stringify(this.props));
        delete checkNext.selection;
        const checked = !isEqual(JSON.stringify(check), JSON.stringify(checkNext));*/
        const currentParams = this.generateQueryParams(this.props, this.state);
        const prevParams = this.generateQueryParams(prevProps, prevState);
        let currentView = null;
        let prevView = null;
        if (currentParams !== false) {
            currentView = currentParams.reqparams.view;
            delete currentParams.reqparams.view;
        }
        if (prevParams !== false) {
            prevView = prevParams.reqparams.view;
            delete prevParams.reqparams.view;
        }

        if (!isEqual(this.props.visibleColumns, prevProps.visibleColumns) || (prevParams !== false && currentParams !== false && !isEqual(prevParams, currentParams)) || !isEqual(this.props.orderBy, prevProps.orderBy) || !isEqual(this.props.sortBy, prevProps.sortBy) || !isEqual(this.props.groupBy, prevProps.groupBy)) {

            let order = [];
            let sortField = null;
            let sortOrder = null;
            if (!isEqual(this.props.orderBy, prevProps.orderBy)) {
                order = this.props.orderBy || [];
                if (Array.isArray(order)) {
                    if (order.length) {
                        sortField = order[0].field;
                        sortOrder = order[0].direction.toUpperCase() === 'DESC' ? -1 : 1;
                    }
                } else if (order !== null && order !== undefined) {
                    sortField = order.field;
                    sortOrder = order.direction.toUpperCase() === 'DESC' ? -1 : 1;
                }
            } else {
                order = this.state.order || [];
                if (Array.isArray(order)) {
                    if (order.length) {
                        sortField = order[0].field;
                        sortOrder = order[0].direction.toUpperCase() === 'DESC' ? -1 : 1;
                    }
                } else if (order !== null && order !== undefined) {
                    sortField = order.field;
                    sortOrder = order.direction.toUpperCase() === 'DESC' ? -1 : 1;
                }
            }
            const sort = Array.isArray(this.props.sortBy) ? [...this.props.sortBy] : (this.props.sortBy !== null && this.props.sortBy !== undefined ? [this.props.sortBy] : []);

            const load = () => {
                if (!isEqual(this.props.visibleColumns, prevProps.visibleColumns) || !isEqual(currentParams.visibleColumns, prevParams.visibleColumns) || !isEqual(prevView, currentView) || !isEqual(this.props.columns, prevProps.columns)) {
                    this.setPersistenceState({
                        visibleColumns: !isEqual(this.props.visibleColumns, prevProps.visibleColumns) ? this.props.visibleColumns : currentParams.visibleColumns,
                        order,
                        sort,
                        sortField,
                        sortOrder,
                        group: this.props.groupBy || []
                    });
                }
                this.loadData(true);
            }

            const preFilters = this.state.preFilters || {};

            if ((prevParams.reqparams || {}).page + "" === "" + (currentParams.reqparams || {}).page && parseInt((currentParams.reqparams || {}).page) > 0) {
                this.setPersistenceState({
                    paging: {...this.state.paging, first: 0},
                    order,
                    sort,
                    sortField,
                    sortOrder,
                    group: this.props.groupBy || [],
                    preFilters,
                }, load);
            } else {
                load();
            }
        } else if (prevProps.formId !== this.props.formId) {
            this.refreshBackground();
        }
    }

    componentDidMount() {
        this.loadData(true);
    }

    refresh = () => {
        this.loadData(true);
    }

    refreshBackground = () => {
        this.loadDataBackground(null, null, null);
    }

    onItemRemove = async (item) => {
        if (this.props.onItemRemove) {
            const remove = await this.props.onItemRemove(item);
            if(remove !== false) {
                const items = [{
                    [this.props.componentListFieldConfig.idfield]: item[this.props.componentListFieldConfig.idfield],
                    [this.props.componentListFieldConfig.componentname + "_id"]: item[this.props.componentListFieldConfig.idfield],
                    [this.props.componentConfig.componentname + "_id"]: typeof this.props.data === "undefined"  ? this.props.parentid : this.props.data[this.props.componentConfig.idfield]
                }];
                const actionparams = {
                    parentcomponent: this.props.componentConfig.componentname,
                    listfield: this.props.name,
                    parentid: this.props.data[this.props.componentConfig.idfield],
                    action: "componentlist.removeItemsFromList",
                    items: items
                };
                await postData(actionparams);
            }
        } else {
            const items = [{
                [this.props.componentListFieldConfig.idfield]: item[this.props.componentListFieldConfig.idfield],
                [this.props.componentListFieldConfig.componentname + "_id"]: item[this.props.componentListFieldConfig.idfield],
                [this.props.componentConfig.componentname + "_id"]: typeof this.props.data === "undefined"  ? this.props.parentid : this.props.data[this.props.componentConfig.idfield]
            }];
            const actionparams = {
                parentcomponent: this.props.componentConfig.componentname,
                listfield: this.props.name,
                parentid: this.props.data[this.props.componentConfig.idfield],
                action: "componentlist.removeItemsFromList",
                items: items
            };
            await postData(actionparams);
        }
        this.loadDataBackground(null, null, null);
        this.forceUpdate();
    }

    onItemsRemove = async (removeItems) => {
        if (this.props.onItemsRemove) {
            const remove = await this.props.onItemsRemove(removeItems);
            if(remove !== false) {
                const items = removeItems.map((item) => ({
                    [this.props.componentListFieldConfig.idfield]: item[this.props.componentListFieldConfig.idfield],
                    [this.props.componentListFieldConfig.componentname + "_id"]: item[this.props.componentListFieldConfig.idfield],
                    [this.props.componentConfig.componentname + "_id"]: typeof this.props.data === "undefined"  ? this.props.parentid : this.props.data[this.props.componentConfig.idfield]
                }));
                const actionparams = {
                    parentcomponent: this.props.componentConfig.componentname,
                    listfield: this.props.name,
                    parentid: this.props.data[this.props.componentConfig.idfield],
                    action: "componentlist.removeItemsFromList",
                    items: items
                };
                await postData(actionparams);
            }
        } else {
            const items = removeItems.map((item) => ({
                [this.props.componentListFieldConfig.idfield]: item[this.props.componentListFieldConfig.idfield],
                [this.props.componentListFieldConfig.componentname + "_id"]: item[this.props.componentListFieldConfig.idfield],
                [this.props.componentConfig.componentname + "_id"]: typeof this.props.data === "undefined"  ? this.props.parentid : this.props.data[this.props.componentConfig.idfield]
            }));
            const actionparams = {
                parentcomponent: this.props.componentConfig.componentname,
                listfield: this.props.name,
                parentid: this.props.data[this.props.componentConfig.idfield],
                action: "componentlist.removeItemsFromList",
                items: items
            };
            await postData(actionparams);
        }
        this.loadDataBackground(null, null, null);
        this.forceUpdate();
    }

    onEditorValueChange = async (props, value, options) => {
        const ignoreEqual = (options || {}).ignoreEqual || false;
        let old = {...props.value[props.rowIndex]};
        let updatedData = [...props.value];
        let oldvalue = get(updatedData[props.rowIndex], props.fieldName, null);
        set(updatedData[props.rowIndex], props.fieldName, value);
        if (this.props.onItemUpdate && (ignoreEqual || !isEqual(oldvalue, value))) {
            try {
                const updateItem = async (updateItem) => {
                    const parentid = (this.props.data && this.props.data[this.props.componentConfig.idfield]) || this.props.parentid;
                    if (!updateItem) {
                        updateItem = {};
                        Object.keys(this.props.componentListFieldConfig.fielddefs).map((key) => {
                            updateItem[key] = updatedData[props.rowIndex][key];
                        });
                    }
                    if (updateItem[this.props.componentConfig.componentname + "_id"] === undefined) {
                        updateItem[this.props.componentConfig.componentname + "_id"] = parentid;
                    }
                    let actionparams = {
                        parentcomponent: this.props.componentConfig.componentname,
                        listfield: this.props.name,
                        parentid,
                        action: "componentlist." + (updateItem[this.props.componentListFieldConfig.idfield] ? "updateItems" : "addItemsToList"),
                        items: [updateItem]
                    };
                    await postData(actionparams);
                    return true;
                }
                const functionProps = {
                    componentConfig: this.props.componentConfig,
                    updateItem,
                    page: (this.props.pageSize === 0 ? 1 : (Math.floor((this.state.paging.first || 0) / this.state.paging.rows) + 1)),
                    rowOffset: ((this.props.pageSize === 0 ? 1 : (Math.floor((this.state.paging.first || 0) / this.state.paging.rows) + 1)) - 1) * parseInt(this.props.pageSize === 0 ? 0 : (this.state.paging.rows || this.props.pageSize)) + parseInt(props.rowIndex)
                };
                if (this.props.componentListFieldConfig) {
                    functionProps.listfieldComponentConfig = this.props.componentListFieldConfig;
                }
                let update = {};
                if (this.props.onItemUpdate instanceof Function) {
                    update = await this.props.onItemUpdate(updatedData[props.rowIndex], old, props.fieldName/*this.state.data.rows[props.rowIndex]*/, props.rowIndex, functionProps);
                } else if (this.props.name) {
                    update = await updateItem(false);
                }
                if (!this.props.value) {
                    if (update !== false) {
                        if (update === true) {
                            this.loadDataBackground(null, null, null);
                        } else {
                            const data = update !== false ? update : updatedData[props.rowIndex];
                            Object.keys(data).forEach((key) => {
                                this.state.data.rows[props.rowIndex][key] = data[key];
                            });
                            this.loadDataBackground(null, null, null);
                        }
                    } else {
                        set(updatedData[props.rowIndex], props.fieldName, oldvalue);
                        Object.keys(updatedData[props.rowIndex]).forEach((key) => {
                            this.state.data.rows[props.rowIndex][key] = updatedData[props.rowIndex][key];
                        });
                        this.loadDataBackground(null, null, null);
                    }
                }
                this.forceUpdate();
            } catch (e) {
                set(updatedData[props.rowIndex], props.fieldName, oldvalue);
                Object.keys(updatedData[props.rowIndex]).forEach((key) => {
                    this.state.data.rows[props.rowIndex][key] = updatedData[props.rowIndex][key];
                });
                this.loadAggregationValues();
                this.forceUpdate();
                throw e;
            }
        }
    }

    generateQueryParams = (props, state) => {
        if (!props.componentConfig || ((props.listfield || props.name) && !props.componentListFieldConfig)) {
            return false;
        }
        let parameters = props.parameters || [];
        let order = props.orderBy === false ? false : (state.order || []);
        let sort = state.sort || [];
        let group = props.groupBy || state.group || [];

        if (props.onSort) {
            if (state.sortOrder !== 0) {
                let sort = state.sortField ? {field: state.sortField, direction: state.sortOrder > 0 ? 'ASC' : 'DESC'} : null;
                if (props.onSort) {
                    const onSort = props.onSort(state.sortField, state.sortOrder > 0 ? 'ASC' : 'DESC');
                    if (onSort !== undefined && onSort !== null && onSort !== false && onSort !== true) {
                        sort = onSort;
                    } else if (sort === false) {
                        sort = null;
                    }
                }
                sort ? order = {...sort, field: state.sortField} : [];
            }
        }

        let visibleColumns = state.visibleColumns;
        const propsVisibleColumns = Object.keys(props.columns || {}).filter((column) => props.columns[column].visible !== false && props.columns[column].hidden !== true);
        visibleColumns = visibleColumns || props.visibleColumns || (propsVisibleColumns.length ? propsVisibleColumns : null) || Object.keys(props.columns || {});
        let view = {};
        if (props.view) {
            if (typeof props.view === "string") {
                if (props.componentConfig.views && props.componentConfig.views[props.view]) {
                    view = props.componentConfig.views[props.view];
                } else {
                    view = {};
                    //console.warn(`No ${props.view} view definition in ${props.componentConfig.componentname}!`);
                }
            } else if (Array.isArray(props.view)) {
                props.view.map((v) => set(view, v, ""));
            }
        }
        if (props.listfield || props.name) {
            if (!view[props.componentListFieldConfig.idfield]) {
                set(view, props.componentListFieldConfig.idfield, "");
            }
        } else {
            if (!view[props.componentConfig.idfield]) {
                set(view, props.componentConfig.idfield, "");
            }
        }
        view = {...view};
        if ((props.listfield || props.name) && props.componentListFieldConfig && !view[props.componentListFieldConfig.idfield]) {
            view[props.componentListFieldConfig.idfield] = "";
        }
        if (props.groupField) {
            set(view, props.groupField, "");
        }
        Object.keys(props.columns || {}).map((c) => set(view, c, ""));

        const params = props.reqparams || {};
        const propsParams = {};

        if (props.listfield || props.name) {
            propsParams.listfield = props.listfield || props.name;
            propsParams.parentcomponent = props.componentConfig.componentname;
            propsParams.parentid = (props.data && props.data[props.componentConfig.idfield]) || props.parentid;
            propsParams.withheader = true;
            if (!(props.data && props.data[props.componentConfig.idfield]) && !props.parentid) {
                return false;
            }
        } else {
            propsParams.component = props.component || props.componentConfig.componentname;
        }

        let reqparams = {
            ...propsParams,
            option: props.option || "componentlist",
            view: view,
            parameters,
            getcolumns: true,
            ...params,
            page: (props.pageSize === 0 ? 1 : (Math.floor((state.paging.first || 0) / state.paging.rows) + 1)),
            itemsperpage: props.pageSize === 0 ? 0 : (state.paging.rows || props.pageSize)
        };
        if (props.filter) {
            reqparams.filter = list(props.filter);
        } else {
            reqparams.filter = [];
        }
        Object.entries(this.state.preFilters).map((entry) => {
            const params = {...(entry[1].params || {})};
            if (params.filter) {
                reqparams.filter = list(reqparams.filter, params.filter);
                delete params.filter;
            }
            reqparams = {
                ...reqparams,
                ...params
            }
        });
        if (props.groupField) {
            reqparams.groupField = props.groupField;
        }
        if (state.paging.filters) {
            Object.entries(state.paging.filters).map((entry) => {
                const key = entry[0];
                const filter = entry[1];
                const column = filter.realField || key;
                if (!visibleColumns || (visibleColumns && visibleColumns.indexOf(column) !== -1)) {
                    const value = filter.value;
                    const operator = filter.operator || "LIKE";
                    const matchmode = filter.matchmode || "any";
                    let valid = false;
                    if ((get(props, "columns." + column + ".filterValidator") || get(props, "columns." + column + ".filterable.expertFilter") || get(props, "columns." + column + ".filterable.type.expertFilter"))) {
                        if (get(props, "columns." + column + ".filterValidator")) {
                            valid = props.columns[column].filterValidator(filter);
                        } else {
                            valid = filter;
                        }
                    } else if (operator.toUpperCase() === "LIKE" && value.length >= (props.minLength || config.minimumLengthOfSearch)) {
                        valid = true;
                    } else if (operator.toUpperCase() !== "LIKE") {
                        valid = true;
                    }
                    if (valid) {
                        if (valid === true) {
                            valid = {
                                field: key,
                                value: typeof(value) === "string" ? value.trim() : value,
                                operator: operator,
                                matchmode: matchmode
                            };
                        }
                        reqparams.filter.push(valid);
                    }
                }
            });
        }
        if (props.aggregations !== true && props.aggregations !== undefined) {
            reqparams.aggregations = props.aggregations;
        }
        if ((reqparams.filter || []).length > 0) {
            reqparams.filter = JSON.stringify(reqparams.filter);
        } else {
            delete reqparams.filter;
        }
        const orders = JSON.parse(JSON.stringify(Array.isArray(order) ? order : [order]));
        if (!!order) reqparams.order = orders.map((o) => {
            if (o.expression !== undefined) {
                delete o.field;
            }
            return o;
        });
        const sorts = JSON.parse(JSON.stringify(Array.isArray(sort) ? sort : [sort]));
        if (reqparams.order) {
            if (props.groupField) {
                reqparams.order = JSON.stringify([ ...sorts, ...reqparams.order]);
            } else {
                reqparams.order = JSON.stringify([...reqparams.order, ...sorts]);
            }
        } else {
            if (sorts.length) {
                reqparams.order = JSON.stringify([...sorts]);
            }
        }
        if (!!group) reqparams.group = JSON.stringify(group);
        let sortField = null;
        let sortOrder = null;
        if (Array.isArray(order)) {
            if (order.length) {
                sortField = order[0].field;
                sortOrder = order[0].direction.toUpperCase() === 'DESC' ? -1 : 1;
            }
        } else if (order !== null && order !== undefined && order !== false) {
            sortField = order.field;
            sortOrder = order.direction.toUpperCase() === 'DESC' ? -1 : 1;
        }
        return {reqparams, visibleColumns, view, sortField, sortOrder, filters: reqparams.filter, value: props.value, order, group};
    }

    loadAggregationValues = () => {
        this.lastaggregationrequest && this.lastaggregationrequest.abort();
        let generatedParams = this.generateQueryParams(this.props, this.state);
        if (generatedParams) {
            this.lastaggregationrequest = sendRequest(generatedParams.reqparams);
            this.lastaggregationrequest.then((data) => {
                this.setPersistenceState({
                    data: {...this.state.data, aggregations: data.aggregations, groupAggregations: data.groupAggregations}
                });
            });
        }
    }

    loadData = (paging) => {
        return new Promise((resolve, reject) => {
            const load = () => {
                if (paging === true) {
                    paging = this.state.paging || {first: 0, rows: this.props.pageSize === 0 ? 0 : (this.props.pageSize || 10)};
                }
                paging = JSON.parse(JSON.stringify(paging));
                this.setPersistenceState({
                    paging: paging,
                    loading: true,
                    data: this.props.virtualScroll ? this.state.data : {
                        rows: [],
                        //cols: [],
                        aggregations: [],
                        groupAggregations: [],
                    },
                    //columns: [],
                    emptyMessage: this.props.virtualScroll ? "" : (this.props.loadingMessage !== undefined && this.props.loadingMessage !== null ? this.props.loading : "Betöltés kérem várjon...")
                }, () => {
                    let generatedParams = this.generateQueryParams(this.props, this.state);
                    if (!generatedParams) {
                        if (this.props.beforeLoad) {
                            this.props.beforeLoad({});
                        }
                        this.setPersistenceState({
                            loading: false,
                            data: {
                                rows: [],
                                //cols: [],
                                aggregations: [],
                                groupAggregations: [],
                            },
                            editor: {rowIndex: null, column: null},
                            emptyMessage: this.props.virtualScroll ? "" : (this.props.emptyMessage !== undefined && this.props.emptyMessage !== null ? this.props.emptyMessage : "Nincs találat")
                        }, () => {
                            if (this.props.onLoadCompleted) {
                                this.props.onLoadCompleted({});
                            }
                            reject({});
                        });
                    } else {
                        const l = this.loadDataBackground(generatedParams, paging, {rowIndex: null, column: null});
                        l.then((state) => {
                            resolve(state);
                        });
                        l.catch((e) => {
                            if (!(e instanceof axios.Cancel) && e.message) {
                                console.log(e);
                                this.setPersistenceState({
                                    loading: false,
                                    data: {
                                        rows: [],
                                        //cols: [],
                                        aggregations: [],
                                        groupAggregations: [],
                                    },
                                    editor: {rowIndex: null, column: null},
                                    emptyMessage: (this.props.emptyMessage !== undefined && this.props.emptyMessage !== null ? this.props.emptyMessage : "Nincs találat")
                                }, () => {
                                    if (this.props.onLoadCompleted) {
                                        this.props.onLoadCompleted({});
                                    }
                                    reject({});
                                });
                            }
                        });
                    }
                });
            }
            if (!this.props.componentConfig || ((this.props.listfield || this.props.name) && !this.props.componentListFieldConfig)) {
                this.setPersistenceState({
                    loading: false,
                    data: {
                        rows: [],
                        //cols: [],
                        aggregations: [],
                        groupAggregations: [],
                    },
                    editor: {rowIndex: null, column: null},
                    emptyMessage: this.props.virtualScroll ? "" : (this.props.emptyMessage !== undefined && this.props.emptyMessage !== null ? this.props.emptyMessage : "Nincs találat")
                }, () => {
                    if (this.props.onLoadCompleted) {
                        this.props.onLoadCompleted({});
                    }
                    reject({});
                });
            } else {
                load();
            }
        });
    }

    loadDataBackground = (generatedParams, paging, editor) => {
        paging = paging || this.state.paging || {first: 0, rows: this.props.pageSize === 0 ? 0 : (this.props.pageSize || 10)};
        paging = JSON.parse(JSON.stringify(paging));
        generatedParams = generatedParams || this.generateQueryParams(this.props, this.state);
        if (!generatedParams) return new Promise(() => {});
        return new Promise((resolve, reject) => {
            if (this.props.beforeLoad) {
                this.props.beforeLoad({});
            }
            let {reqparams, visibleColumns, view, sortField, sortOrder, filters, order, group} = generatedParams;
            const sorted = [...Object.keys(this.props.columns || {}), ...Object.keys(view || {})].filter((value, index, self) => self.indexOf(value) === index);
            if (this.props.value) {

                let rowValues = JSON.parse(JSON.stringify(this.props.value));

                let items = [];
                let aggregations = [];
                let rowCount = 0;
                if (Array.isArray(rowValues)) {
                    items = rowValues.sort((a,b) => {
                        if (sortField) {
                            return sortOrder > 0 ? get(a, sortField) > get(b, sortField) : get(a, sortField) < get(b, sortField);
                        }
                    }).slice(this.state.paging.first, this.state.paging.first + this.state.paging.rows);
                    rowCount = rowValues.length;
                } else {
                    items = (rowValues.items || []).sort((a,b) => {
                        if (sortField) {
                            return sortOrder > 0 ? get(a, sortField) > get(b, sortField) : get(a, sortField) < get(b, sortField);
                        }
                    }).slice(this.state.paging.first, this.state.paging.first + this.state.paging.rows);
                    rowCount = (rowValues.items || []).length;
                    aggregations = rowValues.aggregations || [];
                }

                const Type = this.props.type || SelectorTable;

                if (this.props.formatRows) {
                    items = this.props.formatRows((Type.formatRows || ((rows) => rows))(JSON.parse(JSON.stringify(items))), items);
                }

                visibleColumns = visibleColumns || view;

                let data = {
                    value: rowValues,
                    rows: items,
                    cols: this.props.columns,
                    aggregations,
                    columns: []
                };

                const state = {
                    loading: false,
                    view: view,
                    visibleColumns,
                    data,
                    sorted,
                    columns: {},
                    totalRecords: parseInt(rowCount, 10),
                    paging: paging,
                    emptyMessage: (this.props.emptyMessage !== undefined && this.props.emptyMessage !== null ? this.props.emptyMessage : "Nincs találat"),
                    filters,
                    order,
                    group,
                    sortField,
                    sortOrder
                };

                if (editor) {
                    state.editor = editor;
                }

                this.setPersistenceState(state, () => {
                    resolve(this.state);
                });
            } else {
                this.lastaggregationrequest && this.lastaggregationrequest.abort();
                this.lastrequest && this.lastrequest.abort();
                this.lastrequest = sendRequest(reqparams);
                this.lastrequest.then(async (response) => {

                    let items = response.items || [];

                    const Type = this.props.type || SelectorTable;

                    visibleColumns = visibleColumns || view;

                    let data = {
                        rows: items,
                        cols: response.columns,
                        aggregations: response.aggregations,
                        groupAggregations: response.groupAggregations,
                        columns: response.columns,
                    };

                    if (this.props.onLoadCompleted) {
                        const formattedData = await this.props.onLoadCompleted({...data, fullcount: response.fullcount}, reqparams);
                        if (formattedData !== null && formattedData !== undefined) {
                            data = formattedData;
                        }
                    }
                    if (this.props.formatRows) {
                        data.rows = this.props.formatRows((Type.formatRows || ((rows) => rows))(JSON.parse(JSON.stringify(data.rows))), data.rows);
                    }

                    const state = {
                        loading: false,
                        view: view,
                        visibleColumns,
                        data,
                        sorted: sorted,
                        columns: data.columns,
                        totalRecords: parseInt(response.fullcount, 10),
                        paging: {...paging, first: Math.min(paging.first, Math.round(Math.floor(response.fullcount / paging.rows) * paging.rows))},
                        emptyMessage: (this.props.emptyMessage !== undefined && this.props.emptyMessage !== null ? this.props.emptyMessage : "Nincs találat"),
                        filters,
                        order,
                        group,
                        sortField,
                        sortOrder
                    };

                    if (editor) {
                        state.editor = editor;
                    }

                    this.setPersistenceState(state, () => {
                        resolve(this.state);
                    });
                }).catch((e) => {
                    reject(e);
                });
            }
        });
    }

    onSort = (e) => {
        let order = [];
        // TODO multiSort esetén majd
        /*let order = this.state.order.filter((o) => {
            return o.field !== e.sortField;
        });*/
        if (e.sortOrder !== 0) {
            let sort = {field: e.sortField, direction: e.sortOrder > 0 ? 'ASC' : 'DESC'};
            if (this.props.onSort) {
                const onSort = this.props.onSort(e.sortField, e.sortOrder > 0 ? 'ASC' : 'DESC');
                if (onSort !== undefined && onSort !== null && onSort !== false && onSort !== true) {
                    sort = onSort;
                } else if (sort === false) {
                    sort = null;
                }
            }
            sort && order.push({...sort, field: e.sortField});
        }
        let sortField = null;
        let sortOrder = null;
        if (order.length > 0) {
            sortField = order[0].field;
            sortOrder = order[0].direction.toUpperCase() === 'DESC' ? -1 : 1;
        }
        this.setPersistenceState({
            order,
            sortField,
            sortOrder
        }, () => this.loadData(true));
    };

    onRowReorder = async (e) => {
        if (this.props.isOrderAble && this.props.onRowReorder) {
            const oldIndex = e.dragIndex;
            const newIndex = e.dropIndex;
            const field = this.props.rowReOrderBy;
            const sort = (params = {}) => {
                const {componentConfig} = this.props;

                const oldPosition = parseInt(this.state.data.rows[oldIndex][field]);
                const distance = Math.abs(oldIndex - newIndex);
                let newPosition = 0;
                let direction = 0;

                if (this.state.sortOrder > 0) {
                    newPosition = (oldIndex - newIndex) > 0 ? oldPosition - distance : oldPosition + distance;
                    if (oldIndex > newIndex) {
                        direction = 1;
                    } else {
                        // bugfix
                        newPosition--;
                    }
                } else {
                    newPosition = (oldIndex - newIndex) < 0 ? oldPosition - distance : oldPosition + distance;
                    if (oldIndex < newIndex) {
                        direction = 1;
                        // bugfix
                        newPosition++;
                    }
                }
                this.orderRequest && this.orderRequest.abort && this.orderRequest.abort();
                this.orderRequest = postData({
                    action: ((componentConfig || {}).componentname || this.props.option || "componentlist") + ".updateSort",
                    field,
                    from: oldPosition < 1 ? 1 : oldPosition,
                    to: newPosition < 1 ? 1 : newPosition,
                    direction,
                    //role,
                    component: this.props.component,
                    component_id: this.props.componentId,
                    ...params
                });
                this.orderRequest.then(() => {
                    this.refresh();
                });
            };
            if (this.props.onRowReorder instanceof Function) {
                await this.props.onRowReorder({...e, sort});
            } else if (this.props.onRowReorder) {
                await sort();
            }
        }
    }

    onSelectionChange = (e) => {
        if (!this.props.disabled && (this.props.selectionMode || "single") !== "none") {
            if (this.props.onSelectionChange) {
                this.props.onSelectionChange(e);
            }
        }
    };

    onRowDoubleClick = (e) => {
        if (!this.props.disabled && !(this.state.loading || this.props.loading) && ((this.props.selectionMode || "none") === "none")) {
            this.props.onRowDoubleClick && this.props.onRowDoubleClick(e);
        }
    }

    onPage = async (paging) => {
        paging = JSON.parse(JSON.stringify({...paging}));
        paging.filters = {...(this.state.paging.filters || {}), ...paging.filters};
        const currentParams = this.generateQueryParams(this.props, this.state);
        const prevParams = this.generateQueryParams(this.props, {...this.state, paging});

        if (!isEqual(prevParams, currentParams)) {
            return this.loadData(paging);
        }
        return new Promise((resolve, reject) => {
            resolve(this.state);
        });
    }

    onVirtualScroll = async (paging) => {
        paging = JSON.parse(JSON.stringify({...paging}));
        paging.filters = {...(this.state.paging.filters || {}), ...paging.filters};
        const currentParams = this.generateQueryParams(this.props, this.state);
        const prevParams = this.generateQueryParams(this.props, {...this.state, paging});

        if (!isEqual(prevParams, currentParams)) {
            return this.loadData(paging);
        }
        return new Promise((resolve, reject) => {
            resolve(this.state);
        });
    }

    onFilter(/*field, v, operator, validate = true, column, matchmode*/) {
        const args = [].slice.call(arguments);
        let changed = false;
        let paging = JSON.parse(JSON.stringify({...this.state.paging}));
        if (args.length === 2) {
            const column = args[0];
            let filter = args[1];
            if (!filter && get(paging, "filters." + column)) {
                delete paging.filters[column];
                changed = true;
            } else if (filter && get(paging, "filters." + column) && JSON.stringify(get(paging, "filters." + column)) !== JSON.stringify(filter)) {
                paging.filters = paging.filters || {};
                paging.filters[column] = filter;
                changed = true;
            } else if (filter) {
                paging.filters = paging.filters || {};
                paging.filters[column] = filter;
                changed = true;
            }
        } else {
            let field = args[0];
            let v = args[1];
            let operator = args[2];
            let validate = args[3] || true;
            let column = args[4];
            let matchmode = args[5];
            //this.dt.filter(v, col.field, 'in');
            if (v !== undefined && v !== false && v !== null) {
                paging.filters = paging.filters || {};
                paging.filters[field] = {value: v, operator, validate, realField: column, matchmode};
                changed = true;
            } else if (paging.filters && paging.filters[field]) {
                delete paging.filters[field];
                changed = true;
            }
        }
        if (changed) {
            paging.first = 0;
        }

        let currentParams = this.generateQueryParams(this.props, this.state);
        let nextParams = this.generateQueryParams(this.props, {...this.state, paging});
        if (isEqual(currentParams, nextParams)) {
            this.setPersistenceState({paging});
            return;
        }
        if (changed) {
            const currentPreFilters = this.state.preFilters || {};
            let preFilters;
            if (this.state.lockSearch) {
                preFilters = currentPreFilters;
            } else {
                preFilters = Object.entries(currentPreFilters).reduce((all, current) => {
                    return {
                        ...all,
                        [current[0]]: {state: current[1].state || {}}
                    }
                }, {});
            }
            this.setPersistenceState({
                preFilters
            });
            this.loadData(paging);
        }
    }

    exportModel = () => {
        const generatedParams = this.generateQueryParams(this.props, this.state);
        const {reqparams, filters} = generatedParams;
        return (this.props.exports || []).map((exporting, idx) => {
            let exportType = "";
            let text = "";
            let icon = null;
            let addFilters = false;
            let currentPage = false;
            let browserExport = null;
            if (exporting instanceof Object) {
                exportType = exporting.as;
                text = <span> {exporting.label || ""}</span>;
                icon = exporting.icon || null;
                addFilters = exporting.addFilters || addFilters;
                currentPage = exporting.currentPage === true;
                browserExport = exporting.browserExport || browserExport;
            } else {
                exportType = exporting;
                text = exporting;
            }

            if (!generatedParams) {
                return undefined;
            } else {
                if (!currentPage) {
                    reqparams.page = 1;
                    reqparams.itemsperpage = 0;
                }
                //const view = Array.isArray(this.state.view) ? this.state.view : {};

                /*let view = {};
                if (this.props.view) {
                    if (typeof this.props.view === "string") {
                        if (this.props.componentConfig.views && this.props.componentConfig.views[this.props.view]) {
                            view = this.props.componentConfig.views[this.props.view];
                        } else {
                            view = {};
                            console.warn(`No ${this.props.view} view definition in ${this.props.componentConfig.componentname}!`);
                        }
                    } else if (Array.isArray(this.props.view)) {
                        this.props.view.map((v) => set(view, v, ""));
                    }
                }
                if (this.props.listfield || this.props.name) {
                    if (!view[this.props.componentListFieldConfig.idfield]) {
                        set(view, this.props.componentListFieldConfig.idfield, "");
                    }
                } else {
                    if (!view[this.props.componentConfig.idfield]) {
                        set(view, this.props.componentConfig.idfield, "");
                    }
                }
                view = {...view};
                Object.keys(this.props.columns || []).map((c) => set(view, c, ""));*/

                let propsFilter = this.props.filter || [];
                if (!Array.isArray(propsFilter)) {
                    propsFilter = [propsFilter];
                }
                let exportFilter = exporting.filter || [];
                if (!Array.isArray(exportFilter)) {
                    exportFilter = [exportFilter];
                }
                const filter = [...exportFilter, ...propsFilter, ...(addFilters ? (typeof filters === "string" ? JSON.parse(filters) : (filters || [])) : [])];

                const params = exporting.params || {};

                let view = {};
                let labels = null;
                let columns = [];
                if (!exporting.view) {
                    let cols = (this.state.visibleColumns || []).filter((col) => !!this.props.columns[col]);
                    if (this.props.columnSort) {
                        cols = cols.sort(this.props.columnSort instanceof Function ? this.props.columnSort : (a, b) => {
                            return this.props.columnSort.indexOf(a.field) - this.props.columnSort.indexOf(b.field);
                        });
                    }
                    columns = cols;

                    cols = cols.map((col) => {
                        set(view, col, "");
                    });

                    //const columns = this.props.columns ? Object.keys(this.props.columns) : view;
                    if (this.props.columns) {
                        const cols = {...this.props.columns};
                        labels = {};
                        Object.keys(cols).map((col) => {
                            if (cols[col].header && cols[col].header !== col && typeof cols[col].header !== "object") {
                                set(labels, col, cols[col].header);
                            }
                        });
                    }
                } else {
                    view = exporting.view;
                    columns = view;
                    labels = exporting.labels || labels || {};
                    if (this.props.columns) {
                        const cols = {...this.props.columns};
                        Object.keys(cols).map((col) => {
                            if (!get(labels, col) && cols[col].header && cols[col].header !== col && typeof cols[col].header !== "object") {
                                set(labels, col, cols[col].header);
                            }
                        });
                    }
                }

                let getParams = {
                    ...reqparams,
                    //view: columns,
                    view,
                    filter,
                    labels: labels,
                    ...params,
                    resptype: exportType
                };

                if (exporting.paramsParser instanceof Function) {
                    getParams = exporting.paramsParser(getParams);
                }

                let browserExportRef = null;

                if (browserExport) {

                    let BrowserExportType = null;
                    if (browserExport instanceof Object) {
                        BrowserExportType = browserExport.type || BrowserExportType;
                    }
                    if (BrowserExportType instanceof Function) {
                        browserExport = <BrowserExportType
                            ref={(t) => browserExportRef = t}
                            reqparams={getParams}
                            params={exporting}
                            settings={browserExport}
                            props={this.props}
                            state={this.state}
                            labels={labels}
                            columns={columns}
                            index={idx}
                        />;
                    } else if (BrowserExportType instanceof Object) {
                        browserExport = <BrowserExportType
                            ref={(t) => browserExportRef = t}
                            reqparams={getParams}
                            params={exporting}
                            settings={browserExport}
                            props={this.props}
                            state={this.state}
                            labels={labels}
                            columns={columns}
                            index={idx}
                        />;
                    } else {
                        switch (BrowserExportType) {
                            case "excel":
                                browserExport = <Excel
                                    ref={(t) => browserExportRef = t}
                                    reqparams={getParams}
                                    params={exporting}
                                    settings={browserExport}
                                    props={this.props}
                                    state={this.state}
                                    labels={labels}
                                    columns={columns}
                                    index={idx}
                                />;
                                break;
                        }
                    }
                }

                Object.keys(getParams).map((key) => {
                    if (getParams[key] === undefined || (getParams[key] instanceof Array && !getParams[key].length) || (getParams[key] instanceof Object && !Object.keys(getParams[key]).length)) {
                        delete getParams[key];
                    }
                });

                return {
                    label: text,
                    icon: icon,
                    browserExport,
                    command: (e) => {
                        if (browserExport) {
                            browserExportRef && browserExportRef.export();
                        } else {
                            let url = UrlGenerator();
                            delete url.fragment;
                            url.query = getParams;
                            window.open(url.toString(), "_blank");
                        }
                    }
                };
            }
        }).filter((e) => e !== undefined);
    }

    changeEditor = (direction, rowIndex, column) => {
        switch (direction) {
            case "down":
                if (rowIndex + 1 > this.state.data.rows.length - 1) {
                    rowIndex = 0;
                } else {
                    rowIndex += 1;
                }
                this.setPersistenceState({editor: {rowIndex, column}});
                break;
            case "up":
                if (rowIndex - 1 < 0) {
                    rowIndex = this.state.data.rows.length - 1;
                } else {
                    rowIndex -= 1;
                }
                this.setPersistenceState({editor: {rowIndex, column}});
                break;
            case "right":
                const columns = this.getColumns();
                column = columns.map((col, index) => col.field === column ? index : -1).find((index) => index !== -1);
                if (column + 1 > this.state.data.cols.length - 1) {
                    column = 0;
                } else {
                    column += 1;
                }
                let prev = [...columns];
                const nextColumn = [...columns].map((col, index) => index >= column && col.editor ? index : -1).find((index) => index !== -1);
                if (nextColumn !== undefined && nextColumn !== null) {
                    this.setPersistenceState({editor: {rowIndex, column: nextColumn}});
                } else {
                    column = prev.map((col, index) => col.editor ? index : -1).find((index) => index !== -1);
                    this.setPersistenceState({editor: {rowIndex, column}});
                }
                break;
        }
    }

    onEdit = (rowIndex, column) => {
        this.setPersistenceState({editor: {rowIndex, column}});
    }

    onEditClose = (rowIndex, column) => {
        this.setPersistenceState({editor: {rowIndex: null, column: null}});
    }

    setEditor = (rowIndex, column) => {
        if (typeof column === "number") {
            column = Object.keys(this.props.columns || {})[column];
        } else {
            let name = this.props.name || "";
            if (name) {
                name = name + ".";
            }
            column = name + column;
        }
        this.setPersistenceState({editor: {rowIndex, column}});
    }

    columnsRender = (sorted, visibleColumns, paging, name, columns) => {
        const collist = (sorted || Object.keys(columns));
        const nowidth = collist.map((colname) => {
            if (this.props.columns && this.props.columns.hasOwnProperty(colname)) {
                let colSettings = this.props.columns[colname];
                if (!colSettings.width) {
                    return colname;
                }
            }
            return false;
        }).find((c) => !c) || collist[0];
        /*const columns = */ const cols = collist.map((colname, idx) => {
                if ((visibleColumns && visibleColumns.length ? visibleColumns : Object.keys(columns)).indexOf(colname) !== -1) {
                    let col = {};
                    if (this.props.columns && this.props.columns.hasOwnProperty(colname)) {
                        let colSettings = this.props.columns[colname];
                        let className = !!colSettings.width ? {[(!isNaN(colSettings.width) ? "cell-" + (colSettings.width || Math.floor(12 / sorted.length)) : colSettings.width)]: (this.props.name && this.props.actions !== false && this.props.itemActions !== false) ? nowidth !== colname : true} : {};
                        if (typeof colSettings.className === "object") {
                            className = {...className, ...colSettings.className};
                        } else if (colSettings.className instanceof Function) {
                            className = {...className, ...colSettings.className()};
                        } else if(colSettings.className !== undefined && colSettings.className !== null) {
                            className = {...className, ...{[colSettings.className]: true}};
                        }
                        let label = ((get(this.state, "data.columns") || {})[colname] || {}).label;
                        label = label === colname ? null : label;
                        col = {
                            field: colname,
                            operator: colSettings.operator,
                            matchmode: colSettings.matchmode,
                            header: label || colSettings.header || (columns[colname] && columns[colname].label) || colname,
                            rowOrder: this.props.isOrderAble && this.props.rowReOrderBy === colname && this.state.sortField === colname,
                            filterable: (colSettings.filterable || false),
                            filterField: (colSettings.filterField || false),
                            sortable: (colSettings.sortable || false),
                            className: className,
                            columnClassName: colSettings.columnClassName,
                            columnCss: colSettings.columnCss,
                            onHover: colSettings.onHover,
                            onLeave: colSettings.onLeave,
                            onFilter: colSettings.onFilter,
                            tooltip: colSettings.tooltip,
                            aggregationProps: colSettings.aggregationProps,
                            tooltipOptions: colSettings.tooltipOptions,
                        };
                        if (colSettings.renderer) {
                            let renderer = colSettings.renderer;
                            col.renderer = (v, props) => {
                                const {rowIndex} = props;
                                return renderer(get(v, colname), v, rowIndex, props, this);
                            }
                        } else {
                            col.renderer = (v, {rowData, rowIndex}) => {
                                return get(v, colname);
                            }
                        }
                        if (colSettings.aggregation) {
                            let aggregation = colSettings.aggregation;
                            col.aggregation = (v, props) => {
                                const {rowIndex} = props;
                                return aggregation(get(v, colname), v, rowIndex, props, this);
                            }
                        } else {
                            col.aggregation = col.renderer;
                        }
                        if (colSettings.editor) {
                            col.editor = colSettings.editor(this);
                        }
                        if (colSettings.validator) {
                            col.validator = colSettings.validator(this);
                        }
                        //console.log(col.field);
                    } else if(columns[colname]) {
                        col = columns[colname];
                        col.field = colname;
                        col.filterable = false;
                        col.filterField = false;
                        col.sortable = false;
                        col.rowOrder = false;
                        col.header = col.header || col.label || colname;
                        //griddata.cols.push(col);
                        //console.log(col.field);
                    } else {
                        return undefined;
                    }

                    return {
                        key: idx,
                        field: (name || "") + col.field,
                        fieldName: col.field,
                        columnClassName: col.columnClassName,
                        columnCss: col.columnCss,
                        onHover: col.onHover,
                        onLeave: col.onLeave,
                        tooltip: col.tooltip,
                        tooltipOptions: col.tooltipOptions,
                        header: col.header,
                        rowOrder: col.rowOrder,
                        filter: !!col.filterable,
                        sortable: col.sortable,
                        sortField: col.field,
                        editor: !this.props.disabled && col.editor,
                        editorValidator: col.validator,
                        filterElement: <GridFilter
                            delay="600"
                            field={col.field}
                            filterField={col.filterField}
                            value={get(paging, "filters." + (col.filterField || col.field) + ".value")}
                            filter={get(paging, "filters." + (col.filterField || col.field))}
                            onFilter={(filter) => {
                                this.onFilter(col.field, filter);
                            }}
                            saveChanges={(field, value) => {
                                let validate = !(col.filterable !== true && col.filterable);
                                field = col.filterField || col.field;
                                let operator = col.operator || null;
                                let column = col.field;
                                let matchmode = col.matchmode;
                                if (col.onFilter) {
                                    let params = col.onFilter(field, value, operator, validate, column, matchmode);
                                    if (params !== undefined) {
                                        if (params instanceof Object) {
                                            field = params.field || field;
                                            value = params.value || value;
                                            operator = params.operator || operator;
                                            validate = params.validate || validate;
                                            column = params.column || column;
                                            matchmode = params.matchmode || matchmode;
                                        }
                                    }
                                }
                                this.onFilter(field, value, operator, validate, column, matchmode);
                            }}
                        >
                            {col.filterable !== true && col.filterable}
                        </GridFilter>,
                        body: col.renderer,
                        aggregation: col.aggregation,
                        aggregationProps: col.aggregationProps,
                        className: classNames(col.className)
                    }
                }
            }
        ).filter((el) => el !== undefined);
        if (this.props.name && this.props.actions !== false && this.props.itemActions !== false) {
            let header = <Fragment>&nbsp;</Fragment>;
            if (this.props.addButton === undefined || this.props.addButton !== false) {
                if (this.props.addButton !== undefined && this.props.addButton !== true) {
                    let button;
                    if (this.props.addButton === "list") {
                        button = ModalAdd;
                    } else if (this.props.addButton) {
                        button = this.props.addButton;
                    }
                    if (button) {
                        header = <PropsProxy
                            {...this.props}
                            onItemRemove={this.onItemRemove}
                            addNewRows={this.addNewRows}
                        >
                            {button}
                        </PropsProxy>;
                    }
                } else {
                    header = <Button
                        className={classNames("listfield-add btn-xs", {disabled: this.props.disabled || this.props.loading})}
                        color={this.state.addRowCollapse ? "primary" : "default"} icon={{lib: "fa", name: "plus"}}
                        onClick={(e) => {
                            e && e.preventDefault();
                            if (this.props.disabled || this.props.loading) return;
                            if (this.props.addRowFunction) {
                                this.props.addRowFunction({event: e, addNewRows: this.addNewRows});
                            } else {
                                this.promisedSetState({addRowCollapse: !this.state.addRowCollapse});
                            }
                        }}
                    />;
                }
            }
            cols.unshift({
                key: cols.length,
                filter: false,
                sortable: false,
                editor: false,
                header,
                className: "cell-listfield-actions",
                body: (v, {rowData, rowIndex}) => {
                    return <Actions this={this} props={this.props} state={this.state} item={v} rowIndex={rowIndex} onItemRemove={this.onItemRemove} addNewRow={(item) => this.addNewRows([item])} />
                }
            });
        }
        return cols;
    }

    getColumns = () => {
        return this.columnsRender(this.state.sorted, this.state.visibleColumns, this.state.paging, name, this.state.columns || {});
    }

    addNewRows = async (items) => {
        const addRowProps = {...(this.props.addRowProps ? this.props.addRowProps : {})};
        const listComponent = addRowProps.component || this.props.componentListFieldConfig.componentname;
        const componentConfig = await getComponentConfig(listComponent);
        if (this.props.onAddRows) {
            let addItems = await this.props.onAddRows(items);
            if (addItems !== false && addItems !== undefined && addItems !== null && addItems !== true) {
                addItems = addItems.map((addItem) => {
                    if (addItem[this.props.componentConfig.componentname + "_id"] === undefined) {
                        addItem[this.props.componentConfig.componentname + "_id"] = this.props.data[this.props.componentConfig.idfield];
                    }
                    return addItem;
                });
                const items = [
                    // [this.props.componentConfig.componentname + "_id"]: item[this.props.componentConfig.componentname + "_id"] || this.props.data[this.props.componentConfig.idfield],
                    ...addItems
                ];
                const actionparams = {
                    parentcomponent: this.props.componentConfig.componentname,
                    listfield: this.props.name,
                    parentid: this.props.data[this.props.componentConfig.idfield],
                    action: "componentlist.addItemsToList",
                    items: items.map((item) => ({data: item}))
                };
                await postData(actionparams);
                this.refresh();
                return;
            }
            items = addItems !== true ? addItems : items;
        }
        if (items !== false && items !== undefined && items !== null) {
            const parentid = (this.props.data && this.props.data[this.props.componentConfig.idfield]) || this.props.parentid;
            items = items.map((item) => ({
                    [componentConfig.idfield]: item[componentConfig.idfield],
                    [this.props.componentConfig.componentname + "_id"]: parentid
                })
            );
            const actionparams = {
                parentcomponent: this.props.componentConfig.componentname,
                listfield: this.props.name,
                parentid,
                action: "componentlist.addItemsToList",
                items: items.map((item) => ({data: item}))
            };
            await postData(actionparams);
            this.refresh();
        }
    }

    render() {
        const view = Array.isArray(this.state.view) ? this.state.view : [];
        const visibleColumns = this.state.visibleColumns || view;
        let selection = null;
        let possibleVisibleColumns = [];
        const stateColumns = this.getColumns() || [];
        let cols = [...stateColumns];
        //if (!this.state.loading) {
        selection = this.props.selection || null;
        if (selection instanceof Function) {
            selection = selection(this.state.data.rows);
        }
        if ((this.props.selectionMode || "single") === "single") {
            let config = this.props.componentConfig;
            if (this.props.listfield || this.props.name) {
                config = this.props.componentListFieldConfig;
            }
            if (config) {
                if (config.idfield && selection) {
                    const idfield = config.idfield;
                    selection = this.state.data.rows.filter((item) => (selection instanceof Object ? selection[idfield] : selection) + "" === "" + (item instanceof Object ? item[idfield] : item));
                } else {
                    selection = null;
                }
            }
        } else if ((this.props.selectionMode || "single") === "multiple") {
            let config = this.props.componentConfig;
            if (this.props.listfield || this.props.name) {
                config = this.props.componentListFieldConfig;
            }
            if (config) {
                if (config.idfield && selection) {
                    if (!Array.isArray(selection)) {
                        selection = [selection];
                    }
                    const idfield = config.idfield;
                    selection = this.state.data.rows.filter((item) => !!selection.find((select) => (select instanceof Object ? select[idfield] : select) + "" === "" + (item instanceof Object ? item[idfield] : item)));
                } else {
                    selection = null;
                }
            }
        }

        let exportModel = this.exportModel() || [];
        const columns = this.props.columns ? Object.keys(this.props.columns) : view;
        possibleVisibleColumns = columns.map((col) => {
            const column = (this.props.columns && this.props.columns[col]) || {};
            const rcol = (this.state.data.cols && this.state.data.cols[col]) || {};
            let label = ((get(this.state, "data.columns") || {})[col] || {}).label;
            label = label === col ? null : label;
            return {label: label || column.header || rcol.label || col, value: column.field || col};
        });

        if (this.props.columnSort) {
            cols = cols.sort(this.props.columnSort instanceof Function ? this.props.columnSort : (a, b) => {
                return this.props.columnSort.indexOf(a.field) - this.props.columnSort.indexOf(b.field);
            });
            // TODO a function-nek illene ugyan azt az értéket oda adni!
            possibleVisibleColumns = possibleVisibleColumns.sort(this.props.columnSort instanceof Function ? this.props.columnSort : (a, b) => {
                return this.props.columnSort.indexOf(a.value) - this.props.columnSort.indexOf(b.value);
            });
        }

        cols = cols.map((col) => {
            let c = {...col};
            c.filter = c.filter || false;
            c.sortable = c.sortable || false;
            delete c.editor;
            delete c.editorValidator;
            let fieldProps = {
                disabled: this.props.disabled, onEdit: this.onEdit, onEditClose: this.onEditClose,
                up: (row, column) => this.changeEditor("up", row, column),
                down: (row, column) => this.state.data.rows.length > 1 && this.changeEditor("down", row, column),
                right: (row, column) => this.changeEditor("right", row, column),
                cancel: (row, column) => this.setPersistenceState({editor: {rowIndex: null, column: null}}),
            };
            c.body = (rowData, props) => {
                const Props = {
                    ...fieldProps,
                    ...props,
                    ...col,
                    className: "",//{classNames(col.columnClassName && col.columnClassName(col.field, rowData[col.field], rowData))}
                    value: this.state.data.rows,
                    rowIndex: props.rowIndex,
                    rowOffset: ((this.props.pageSize === 0 ? 1 : (Math.floor((this.state.paging.first || 0) / this.state.paging.rows) + 1)) - 1) * parseInt(this.props.pageSize === 0 ? 0 : (this.state.paging.rows || this.props.pageSize)) + props.rowIndex,
                    rows: this.state.data.rows,
                    active: this.state.editor.rowIndex === props.rowIndex && this.state.editor.column === col.field,
                    sortOrder: this.state.sortOrder,
                    rowData,
                };
                return <EditorField {...Props} onRowReorder={this.onRowReorder} />
            };
            c.aggregation = (rowData, props) => {
                const Props = {
                    ...fieldProps,
                    ...props,
                    ...col,
                    className: "",//{classNames(col.columnClassName && col.columnClassName(col.field, rowData[col.field], rowData))}
                    value: this.state.data.rows,
                    rowIndex: props.rowIndex,
                    rowOffset: ((this.props.pageSize === 0 ? 1 : (Math.floor((this.state.paging.first || 0) / this.state.paging.rows) + 1)) - 1) * parseInt(this.props.pageSize === 0 ? 0 : (this.state.paging.rows || this.props.pageSize)) + props.rowIndex,
                    rows: this.state.data.rows,
                    active: this.state.editor.rowIndex === props.rowIndex && this.state.editor.column === col.field,
                    rowData,
                    body: col.aggregation,
                    editor: false,
                    sortOrder: this.state.sortOrder,
                    isAggregation: true
                };
                return <EditorField {...Props} onRowReorder={this.onRowReorder} />
            };
            c.className = classNames(col.className, {
                "p-editable-column": true,
                "p-cell-editing": true
            });
            return c;
        });
        /*} else {
            cols = [
                <Column
                    key={0}
                    field={"noneof"}
                    header={" "}
                />
            ];
        }*/

        let aggregations = null;
        let aggregationRows = [];
        let groupAggregationRows = [];
        if ((this.props.aggregations || this.state.data.aggregations) && this.state.data.rows.length && this.props.aggregationsVisible !== false) {
            const cell2D = {};
            aggregationRows = this.state.data.aggregations || [];
            groupAggregationRows = this.state.data.groupAggregations || [];
            const rows = (this.state.data.aggregations || []).map((rowData, rowIndex) => {
                const columns = cols.map((col, columnIndex) => {
                    let currentColSpan = 0;
                    let currentRowSpan = 0;
                    const colSettings = cols.find((c) => c.fieldName === col.fieldName);

                    const props = (colSettings.aggregationProps instanceof Function ? colSettings.aggregationProps(rowData, {...col, rowData, rowIndex}) : colSettings.aggregationProps) || {};
                    if (props.colSpan) {
                        currentColSpan = (props.colSpan || 1);
                    } else {
                        if (props.colSpan !== undefined) {
                            delete props.colSpan;
                        }
                    }
                    if (props.rowSpan) {
                        currentRowSpan = (props.rowSpan || 1);
                    } else {
                        if (props.rowSpan !== undefined) {
                            delete props.rowSpan;
                        }
                    }
                    if(cell2D[rowIndex] === undefined) {
                        cell2D[rowIndex] = {};
                    }
                    //console.log(rowIndex, columnIndex, currentColSpan);
                    //console.log(rowIndex, columnIndex, currentRowSpan);
                    if (currentColSpan > 0) {
                        for (let i = columnIndex; i < columnIndex + currentColSpan; i++) {
                            if (cell2D[rowIndex][i] === undefined) {
                                cell2D[rowIndex][i] = {};
                            }
                            if (cell2D[rowIndex][i]['col'] === undefined) {
                                if (i === columnIndex) {
                                    cell2D[rowIndex][i]['col'] = currentColSpan;
                                } else {
                                    cell2D[rowIndex][i]['col'] = columnIndex - i;
                                }
                            } else {
                                cell2D[rowIndex][i]['col'] = Math.max(cell2D[rowIndex][i]['col'], cell2D[rowIndex][i]['col'] - i);
                            }
                        }
                    } else {
                        if (cell2D[rowIndex][columnIndex] === undefined) {
                            cell2D[rowIndex][columnIndex] = {};
                        }
                        if (cell2D[rowIndex][columnIndex]['col'] === undefined) {
                            cell2D[rowIndex][columnIndex]['col'] = 0;
                        }
                    }
                    if (currentRowSpan > 0) {
                        for (let i = rowIndex; i < rowIndex + currentRowSpan; i++) {
                            if (cell2D[i] === undefined) {
                                cell2D[i] = {};
                            }
                            for (let colIndex = columnIndex; colIndex <= columnIndex; colIndex++) {
                                if (cell2D[i][colIndex] === undefined) {
                                    cell2D[i][colIndex] = {};
                                }
                                if (cell2D[i][colIndex]['row'] === undefined) {
                                    if (i === rowIndex) {
                                        cell2D[i][colIndex]['row'] = currentRowSpan;
                                    } else {
                                        cell2D[i][colIndex]['row'] = rowIndex - i;
                                    }
                                } else {
                                    cell2D[i][colIndex]['row'] = Math.max(cell2D[i][colIndex]['row'], cell2D[i][colIndex]['row'] - i);
                                }
                            }
                        }
                    } else {
                        for (let i = rowIndex; i < rowIndex + currentRowSpan; i++) {
                            if (cell2D[i] === undefined) {
                                cell2D[i] = {};
                            }
                            for (let colIndex = columnIndex; colIndex <= columnIndex; colIndex++) {
                                if (cell2D[i][colIndex] === undefined) {
                                    cell2D[i][colIndex] = {};
                                }
                                if (cell2D[i][colIndex]['row'] === undefined) {
                                    cell2D[i][colIndex]['row'] = 0;
                                }
                            }
                        }
                    }
                    //console.log(JSON.parse(JSON.stringify(cell2D)));
                    const colSpan = cell2D[rowIndex][columnIndex]['col'];
                    if (colSpan > 0) {
                        props.colSpan = colSpan;
                    } else {
                        if (colSpan < 0) {
                            return null;
                        } else {
                            delete props.colSpan;
                        }
                    }
                    const rowSpan = cell2D[rowIndex][columnIndex]['row'];
                    if (rowSpan > 0) {
                        props.rowSpan = rowSpan;
                    } else {
                        if (rowSpan < 0) {
                            return null;
                        } else {
                            delete props.rowSpan;
                        }
                    }

                    if (colSettings && (((this.props.aggregations !== true ? this.props.aggregations || {} : {}).fields || {})[col.fieldName] || ((this.props.columns || {})[col.fieldName] || {}).aggregation)) {
                        return {
                            footer: colSettings.aggregation(rowData, {...col, rowData, rowIndex}),
                            body: null,
                            ...props
                        };
                    } else {
                        return {
                            footer: false,
                            ...props
                        };
                    }
                }).filter((c) => c).map((props, index) => {
                    return <Column key={index} {...props}/>
                });
                if (columns.length && columns.find((column) => column.props.footer)) {
                    return <Row key={rowIndex}>
                        {columns}
                    </Row>
                }
                return null;
            }).filter((row) => !!row);
            if (rows.length) {
                aggregations = <ColumnGroup>
                    {rows}
                </ColumnGroup>
            }
        }

        let addRow = null;
        if (this.props.addRow) {
            const ro = this.props.addRow instanceof React.Component ? React.cloneElement(this.props.addRow, {...this.props.addRow.props, disabled: this.props.disabled || this.props.addRow.props.disabled}, this.props.addRow.children) : this.props.addRow;
            addRow = <ColumnGroup>
                <Row>
                    {cols.map((col, index) => {
                        return <Column key={index} {...col} />
                    })}
                </Row>
                <Row>
                    <Column header={ro} colSpan={cols.length} />
                </Row>
            </ColumnGroup>;
        } else if (this.props.addRow !== false) {
            let listFieldAddRow = null;
            if (this.props.name && this.props.actions !== false && this.props.itemActions !== false && this.state.addRowCollapse) {
                const addRowProps = {...(this.props.addRowProps ? this.props.addRowProps : {})};
                const listComponent = addRowProps.component || this.props.componentListFieldConfig.componentname;
                let Tag = PropsProxy;
                if (listComponent !== this.props.componentListFieldConfig.componentname) {
                    Tag = ComponentConfig;
                }
                listFieldAddRow = this.props.componentListFieldConfig && <Row>
                    <Column header={
                        <Tag componentName={listComponent}>
                            {(props) => {
                                const componentConfig = props.componentConfig || this.props.componentListFieldConfig;
                                return (
                                    <Select
                                        storeType="remote"
                                        component={componentConfig.componentname}
                                        placeholder="Hozzáadás"
                                        objectValue={true}
                                        openIfHasOptions={true}
                                        valueKey={componentConfig.idfield}
                                        labelKey={this.props.listfieldlabel}
                                        view={view}
                                        label={false}
                                        {...addRowProps}
                                        saveChanges={async (field, item) => {
                                            await this.addNewRows([item]);
                                        }}
                                    />
                                );
                            }}
                        </Tag>
                    } colSpan={cols.length} />
                </Row>
            }
            addRow = <ColumnGroup>
                <Row>
                    {cols.map((col, index) => {
                        return <Column key={index} {...col} />
                    })}
                </Row>
                {listFieldAddRow}
            </ColumnGroup>;
        }

        const Type = this.props.type || SelectorTable;

        if (!cols.length) {
            cols = [
                <Column
                    key={0}
                    field={"noneof"}
                    header={" "}
                />
            ];
        } else {
            cols = cols.map((col, index) => <Column key={index} {...col}/>);
        }

        let paginatorRight = null;

        if (this.props.paginatorRight) {
            if (this.props.paginatorRight instanceof Function) {
                paginatorRight = this.props.paginatorRight({
                    disabled: this.props.disabled || this.state.loading || this.props.loading
                });
            } else {
                paginatorRight = React.cloneElement(this.props.paginatorRight, {
                    ...this.props.paginatorRight.props,
                    disabled: this.props.paginatorRight.props.disabled || this.props.disabled || this.state.loading || this.props.loading
                });
            }
        }

        let importer = <DataGridTableActions
            componentConfig={this.props.componentConfig}
            actions={[Import]}
            request={{
                listfield: this.props.listfield || this.props.name,
                parentid: (this.props.data && this.props.data[this.props.componentConfig.idfield]) || this.props.parentid,
            }}
            {...(this.props.importers || {})}
        />;
        if (paginatorRight) {
            paginatorRight = <Fragment>
                {paginatorRight}
                {importer}
            </Fragment>
        } else {
            paginatorRight = importer;
        }

        const rowGroupHeaderTemplate = this.props.rowGroupHeaderTemplate || this.props.groupField ? (row, index) => {
            if (this.props.rowGroupHeaderTemplate) {
                return this.props.rowGroupHeaderTemplate(row, index, this.state.data.rows, cols);
            }
            return get(row, this.props.groupField);
        } : null;

        const rowGroupFooterTemplate = this.props.rowGroupFooterTemplate ? (row, index) => {
            if (this.props.rowGroupFooterTemplate) {
                return this.props.rowGroupFooterTemplate(row, index, this.state.data.rows, cols);
            }
            return get(row, this.props.groupField);
        } : null;

        const pageSize = this.props.pageSize !== undefined && this.props.pageSize !== null ? parseInt(this.state.paging.rows || "0") || parseInt(this.props.pageSize || "0") : (this.state.paging.rows || (parseInt(this.props.pageSize || "0") === 0 ? this.state.data.rows.length : (parseInt(this.props.pageSize || "0") || 10)));

        const preFilters = Array.isArray(this.props.preFilters) ? this.props.preFilters.reduce((all, c) => ({...all, [c.props.filterName]: c}), {}) : this.props.preFilters;
        const preFilterEntries = Object.entries(preFilters);

        const hasPreFilters = !!preFilterEntries.find((entry) => {
            const key = entry[0];
            const child = entry[1];
            const currentPreFilters = this.state.preFilters || {};
            return child.props.visible === undefined || child.props.visible({
                ...this.props,
                ...child.props,
                state: (currentPreFilters[key] || {}).state || {},
                params: (currentPreFilters[key] || {}).params || {}
            });
        });

        return (
            <div className={classNames(this.props.className)}>
                {
                    hasPreFilters
                        ? <div className="prefilters btn-group">
                            <Button
                                icon={{lib: "fa", name: this.state.lockSearch ? "lock" : "lock-open"}}
                                color={this.state.lockSearch ? "primary" : "default"}
                                onClick={() => {
                                    this.setPersistenceState({
                                        lockSearch: !this.state.lockSearch
                                    })
                                }}
                            />
                        </div>
                        :
                        null
                }
                {
                    preFilterEntries.map((entry, idx) => {
                        const key = entry[0];
                        const child = entry[1];
                        const childProps = {...(child.props || {})};
                        const currentPreFilters = this.state.preFilters || {};
                        return <child.type
                            key={idx}
                            ref={child.ref}
                            {...this.props}
                            {...childProps}
                            state={(currentPreFilters[key] || {}).state || {}}
                            setState={(state, cb) => {
                                const currentPreFilters = this.state.preFilters || {};
                                const preFilters = {
                                    ...currentPreFilters,
                                    [key]: {...(currentPreFilters[key] || {}), state: {...((currentPreFilters[key] || {}).state), ...state}}
                                };
                                this.setPersistenceState({
                                    preFilters
                                }, cb);
                            }}
                            params={(currentPreFilters[key] || {}).params || {}}
                            setParams={(params) => {
                                const currentPreFilters = this.state.preFilters || {};
                                const paging = JSON.parse(JSON.stringify(this.state.paging));
                                let preFilters;
                                if (this.state.lockSearch) {
                                    preFilters = currentPreFilters;
                                    preFilters = {
                                        ...preFilters,
                                        [key]: {...(currentPreFilters[key] || {}), params: params || {}}
                                    };
                                } else {
                                    preFilters = Object.entries(currentPreFilters).reduce((all, current) => {
                                        return {
                                            ...all,
                                            [current[0]]: {state: current[1].state || {}}
                                        }
                                    }, {});
                                    preFilters = {
                                        ...preFilters,
                                        [key]: {...(currentPreFilters[key] || {}), params: params || {}}
                                    };
                                }
                                this.setPersistenceState({
                                    preFilters
                                });
                                this.loadData(paging);
                            }}
                        />;
                    })
                }
                <div className="clearfix"/>
                <Type
                    name={this.props.name}
                    componentConfig={this.props.componentConfig}
                    data={this.props.data}
                    parentid={this.props.parentid}
                    rowGroupMode={this.props.rowGroupMode || (this.props.groupField ? "subheader" : null)}
                    groupField={this.props.groupField}
                    rowGroupHeaderTemplate={rowGroupHeaderTemplate}
                    rowGroupFooterTemplate={rowGroupFooterTemplate}
                    value={this.state.data.rows}
                    aggregationRows={aggregationRows}
                    groupAggregationRows={groupAggregationRows}
                    gridid={this.props.gridid}
                    onRowReorder={this.onRowReorder}
                    selectorgrid={this}

                    rowClassName={this.props.rowClassName}

                    first={this.state.paging.first}
                    className={classNames("table table-hover", {disabled: this.props.disabled})}
                    onPage={async (paging) => {
                        let p = null;
                        if (this.props.onPage) {
                            p = await this.props.onPage(paging);
                        }
                        p = p || paging;
                        return this.onPage(p);
                    }}
                    virtualScroll={this.props.virtualScroll || false}
                    virtualRowHeight={this.props.virtualRowHeight || 30}
                    scrollHeight={this.props.scrollHeight || "200px"}
                    onVirtualScroll={async (paging) => {
                        let p = null;
                        if (this.props.onVirtualScroll) {
                            p = await this.props.onVirtualScroll(paging);
                        }
                        p = p || paging;
                        return this.onVirtualScroll(p);
                    }}
                    scrollable={this.props.virtualScroll || false}
                    resizableColumns={this.props.resizableColumns !== undefined ? this.props.resizableColumns : true}

                    loading={this.state.loading || this.props.loading}

                    footerColumnGroup={aggregations}
                    headerColumnGroup={addRow}

                    paginator={!this.props.virtualScroll && this.props.paginatorVisible !== false}
                    //paginatorPosition={this.props.paginatorPosition || "both"}
                    lazy={true}
                    rows={pageSize}
                    rowsPerPageOptions={pageSize > 0 ? [pageSize, ...(this.props.pageSizes || [5, 10, 15])].filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a - b) : null}
                    totalRecords={this.state.totalRecords || 0}
                    selectionMode={this.props.selectionMode === "none" ? "single" : (this.props.selectionMode || "single")}
                    metaKeySelection={(this.props.selectionMode || "single") === "multiple" ? (this.props.metaKeySelection || false) : false}
                    onSort={this.onSort}
                    sortField={this.state.sortField}
                    sortOrder={this.state.sortOrder}
                    disabled={this.props.disabled}
                    selection={!this.props.disabled && (this.props.selectionMode || "single") !== "none" && selection}
                    emptyMessage={this.state.loading || this.props.loading ? (this.props.loadingMessage !== undefined && this.props.loadingMessage !== null ? this.props.loading : "Betöltés kérem várjon...") : (this.props.emptyMessage !== undefined && this.props.emptyMessage !== null ? this.props.emptyMessage : "Nincs találat")}
                    onSelectionChange={this.onSelectionChange}
                    paginatorLeft={<TextInput
                        className="p-page-number"
                        label={false}
                        disabled={this.props.disabled}
                        type="number"
                        value={(this.state.paging.first / this.state.paging.rows + 1) || 1}
                        onKeyDown={(e, field, first) => { if (!first) return; if (e.which === 38) {first++;} if (e.which === 40) {first--;} const pageNum = (pageSize === 0 ? 0 : Math.max(0, Math.floor(((first || 0) -1) * this.state.paging.rows))); ifCompletedInput(e) && this.onPage({...this.state.paging, first: pageNum});}}
                        onBlur={(e, field, first) => { if (!first) return; if (e.which === 38) {first++;} if (e.which === 40) {first--;} const pageNum = (pageSize === 0 ? 0 : Math.max(0, Math.floor(((first || 0) -1) * this.state.paging.rows))); this.onPage({...this.state.paging, first: pageNum})}}
                    />}
                    paginatorRight={paginatorRight}
                    paginatorTemplate={pageSize > 0 ? "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" : ""}
                    currentPageReportTemplate={"{totalPages}"}
                    showVisibleColumnFilter={this.props.showVisibleColumnFilter === undefined || this.props.showVisibleColumnFilter === true}
                    columns={columns}
                    columnProps={this.props.columns || {}}
                    visibleColumns={visibleColumns}
                    possibleVisibleColumns={possibleVisibleColumns}
                    setPersistenceState={this.setPersistenceState}
                    paging={this.state.paging}
                    loadData={this.loadData}
                    exportModel={exportModel}
                    onRowDoubleClick={this.onRowDoubleClick}
                    actions={this.props.actions === undefined ? true : this.props.actions}
                    {...(this.props.typeSettings || {})}
                >
                    {cols}
                </Type>
                {exportModel.map((exp, idx) => <Fragment key={idx}>{exp.browserExport}</Fragment>)}
            </div>
        );
    }
}

class SelectorGridLabelSearch extends React.Component {

    static propTypes = DefaultSelectorGrid.propTypes;

    constructor(props) {
        super(props);
        this.search = debounce((search) => {
            this.loadComponentRequest && this.loadComponentRequest.abort();
            if (search && search.length >= (this.props.minLength || config.minimumLengthOfSearch)) {
                let component = null;
                if (get(this.props, "componentListFieldConfig")) {
                    component = get(this.props, "componentListFieldConfig.componentname")
                } else if (get(this.props, "componentConfig")) {
                    component = get(this.props, "componentConfig.componentname")
                }
                if (component) {
                    this.loadComponentRequest = loadComponent("componentlist", {
                        component: "Label",
                        filter: [{field: "component_type", value: component}, {
                            field: "text",
                            value: search,
                            operator: "LIKE"
                        }],
                        view: ["component_id"],
                        itemsperpage: 1,
                        aggregations: {
                            fields: {
                                "component_id": {
                                    field: "component_id", type: "GROUP_CONCAT"
                                },
                            }
                        }
                    });
                    this.loadComponentRequest.then((data) => {
                        const ids = (((data || {}).aggregations || [])[0].component_id || "").split(",");
                        this.props.setState({ids});
                        if (ids !== null) {
                            let idField = null;
                            if (get(this.props, "componentListFieldConfig")) {
                                idField = get(this.props, "componentListFieldConfig.idfield")
                            } else if (get(this.props, "componentConfig")) {
                                idField = get(this.props, "componentConfig.idfield")
                            }
                            if (ids.length) {
                                this.props.setParams({filter: {field: idField, value: ids, operator: "IN"}});
                            } else {
                                this.props.setParams({filter: {field: idField, value: [0], operator: "IN"}});
                            }

                        }
                    });
                } else {
                    this.props.setState({ids: null});
                    this.props.setParams({filter: undefined});
                }
            } else {
                this.props.setState({ids: null});
                this.props.setParams({filter: undefined});
            }
        }, 300);
        if (((this.props.params || {}).search || '') !== ((this.props.state || {}).search || '')) {
            this.props.setState({search: (this.props.params || {}).search || ''});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            get(this.props, "componentConfig.componentname") !== get(prevProps, "componentConfig.componentname")
            ||
            get(this.props, "componentListFieldConfig.componentname") !== get(prevProps, "componentListFieldConfig.componentname")
        ) {
            this.props.setState({
                search: '',
                ids: null
            })
        }
        if (JSON.stringify((this.props.params || {}).filter || '') !== JSON.stringify((prevProps.params || {}).filter || '') && ((this.props.params || {}).filter || '') === '') {
            this.props.setState({search: (this.props.params || {}).search || ''});
        }
    }

    refresh = () => {
        this.c && this.c.refresh();
    }

    refreshBackground = () => {
        this.c && this.c.refreshBackground();
    }

    setEditor = (rowIndex, column) => {
        this.c && this.c.setEditor(rowIndex, column);
    }

    addNewRows = async (items) => {
        return this.c && await this.c.addNewRows(items);
    }

    render () {
        if (this.props.listfield || this.props.name) {
            return null;
        }
        return <div className="label-filter">
            <TextInput
                name="search"
                label={false}
                placeholder="Címke/Megjegyzés keresés..."
                value={this.props.state.search}
                saveChanges={(field, value) => {
                    this.props.setState({search: value}, () => {
                        this.search(value);
                    })
                }}
            />
        </div>;
    }
}

class SelectorGridNamedFilterSearch extends React.Component {

    static placeHolder = placeHolderComponent;

    render() {
        const props = {...this.props};
        if (!props.preFilters) {
            props.preFilters = {};
        } else if (Array.isArray(props.preFilters)) {
            props.preFilters = [...props.preFilters];
        }
        if (
            props.namedFilters === undefined
            ||
            props.namedFilters !== false
        ) {
            const f = {
                type: SelectorGridPreFilters,
                props: {
                    visible: (props) => (props.namedFilters === undefined
                        ||
                        props.namedFilters !== false) && !!(props.state.filters || []).length,
                    filterName: "namedFilters",
                    resetAble: "Összes"
                }
            };
            if (Array.isArray(props.preFilters)) {
                props.preFilters.push(f);
            } else {
                props.preFilters.namedFilters = f;
            }
        }
        if (props.searchfield) {
            let f = {
                type: SearchField,
                props: {
                    visible: (props) => props.searchfield,
                    filterName: "searchFilter"
                }
            };
            if (Array.isArray(props.preFilters)) {
                props.preFilters.push(f);
            } else {
                props.preFilters.searchFilter = f;
            }
            f = {
                type: SelectorGridLabelSearch,
                props: {
                    visible: (props) => props.searchfield,
                    filterName: "labelSearch"
                }
            };
            if (Array.isArray(props.preFilters)) {
                props.preFilters.push(f);
            } else {
                props.preFilters.labelSearch = f;
            }
        }
        return <DefaultSelectorGrid ref={props.selectorGridRef} {...props}/>;
    }
}

const ListFieldConfigLoader = (props) => {
    const f = props.listfield || props.name;
    const field = props.listfieldtype || (props.componentConfig.fielddefs[f] || {}).object || (props.componentConfig.fielddefs[f] || {}).objects;
    if (field) {
        return <ComponentConfig componentName={field} componentConfigAs="componentListFieldConfig" componentConfig={props.componentConfig}>
            {props.children}
        </ComponentConfig>
    } else {
        console.error(`Please set the listfieldtype props or define ${f} fielddef in ${props.componentConfig.componentname}, no object or objects field in fielddef!`);
        return <Icon lib="fa" name="exclamation-triangle" />;
    }
}

ListFieldConfigLoader.placeHolder = placeHolderComponent;

class SelectorGridComp extends React.Component {

    static placeHolder = placeHolderComponent;

    static propTypes = DefaultSelectorGrid.propTypes;

    constructor(props) {
        super(props);
        this.Connected = connectAdvanced((dispatch) => {
            return (store, nextOwnProps) => {
                const actions = bindActionCreators({setSelectorGridState}, dispatch);
                return {
                    ...nextOwnProps,
                    ...actions
                }
            }
        },{forwardRef: true})(SelectorGridNamedFilterSearch);
    }

    render () {
        const Component = this.Connected;
        let ret = <Component {...this.props}/>;
        if (this.props.listfield || this.props.name) {
            ret = <ListFieldConfigLoader {...this.props}>
                {ret}
            </ListFieldConfigLoader>
        }
        if (this.props.component) {
            ret = <ComponentConfig componentName={this.props.component}>
                {ret}
            </ComponentConfig>
        }
        return ret;
    }

}

const SelectorGrid = React.forwardRef((props, ref) => {
    return <SelectorGridComp selectorGridRef={ref} {...props} />
});

SelectorGrid.placeHolder = placeHolderComponent;
SelectorGrid.propTypes = DefaultSelectorGrid.propTypes;

export default SelectorGrid;

const ParentFieldSelectorGridComponent = (props) => {
    let selectorList, selectionRequest;
    selectorList = useRef();
    const [selection, setSelection] = useState([]);
    const filter = [{field: props.field, value: props.data[props.componentConfig.idfield]}];
    const reloadSelection = () => {
        return new Promise((resolve) => {
            selectionRequest && selectionRequest.abort();
            const params = {
                option: "componentlist",
                component: props.parentComponentConfig.componentname,
                getcolumns: true,
                withheader: true,
                itemsperpage: 1,
                filter,
                view: [props.parentComponentConfig.idfield],
                aggregations: {
                    fields: {
                        [props.parentComponentConfig.idfield]: {
                            type: "GROUP_CONCAT"
                        }
                    }
                }
            };
            selectionRequest = sendRequest(params);
            selectionRequest.then((response) => {
                setSelection((get(response, "aggregations.0." + props.parentComponentConfig.idfield) || "").split(",").filter(Boolean));
                resolve();
            });
        });
    };
    useEffect(() => {
        reloadSelection();
    }, [props.componentConfig.componentname, props.parentComponentConfig.componentname, props.data[props.componentConfig.idfield]]);
    const addNewRows = async (items) => {
        items.map(async (item) => {
            if (props.parentComponentConfig.fielddefs[props.field].objects) {
                const actionparams = {
                    parentcomponent: props.parentComponentConfig.componentname,
                    listfield: props.field,
                    parentid: item[props.parentComponentConfig.idfield],
                    action: "componentlist.addItemsToList",
                    items: [{
                        [props.componentConfig.componentname + "_id"]: props.data[props.componentConfig.idfield],
                        [props.parentComponentConfig.componentname + "_id"]: item[props.parentComponentConfig.idfield]
                    }]
                };
                await postData(actionparams);
            } else {
                const actionparams = {
                    action: props.parentComponentConfig.componentname + ".update",
                    data: {
                        [props.parentComponentConfig.idfield]: item[props.parentComponentConfig.idfield],
                        [props.field]: props.data[props.componentConfig.idfield]
                    }
                };
                await postData(actionparams);
            }
            await reloadSelection();
            selectorList.current && selectorList.current.refresh();
        });
    };
    const onItemRemove = async (item) => {
        if (props.parentComponentConfig.fielddefs[props.field].objects) {
            const actionparams = {
                parentcomponent: props.parentComponentConfig.componentname,
                listfield: props.field,
                parentid: item[props.parentComponentConfig.idfield],
                action: "componentlist.removeItemsFromList",
                items: [{
                    [props.componentConfig.componentname + "_id"]: props.data[props.componentConfig.idfield],
                    [props.parentComponentConfig.componentname + "_id"]: item[props.parentComponentConfig.idfield]
                }]
            };
            await postData(actionparams);
        } else {
            const actionparams = {
                action: props.parentComponentConfig.componentname + ".update",
                data: {
                    [props.parentComponentConfig.idfield]: item[props.parentComponentConfig.idfield],
                    [props.field]: null
                }
            };
            await postData(actionparams);
        }
        await reloadSelection();
        selectorList.current && selectorList.current.refresh();
    };
    let labelKey;
    if (props.componentConfig.namefield) {
        labelKey = props.componentConfig.namefield;
    } else if ((props.componentConfig.fielddefs || {}).name) {
        labelKey = "name";
    } else if ((props.componentConfig.fielddefs || {}).title) {
        labelKey = "title";
    } else if ((props.componentConfig.fielddefs || {}).label) {
        labelKey = "label";
    }
    const columns = {
        actions: {
            header: <Fragment>
                <ModalAdd
                    componentListFieldConfig={props.parentComponentConfig}
                    selection={selection}
                    selectionFilter={filter}
                    columns={{
                        ...(props.parentComponentConfig.fielddefs[props.field].object && labelKey ? {
                            /*[props.field + "." + labelKey]: {
                                header: ' ',
                                width: 1,
                                sortable: true,
                                filterable: true,
                            }*/
                        } : {}),
                        ...props.columns
                    }}
                    addNewRows={addNewRows}
                    onItemRemove={onItemRemove}
                />
            </Fragment>,
            width: 'cell-button',
            renderer: (value, rowData) => <Actions
                props={{componentListFieldConfig: props.parentComponentConfig}}
                item={rowData}
                onItemRemove={onItemRemove}
            />
        },
        ...props.columns
    };
    return <SelectorGrid
        ref={selectorList}
        componentConfig={props.parentComponentConfig}
        component={props.parentComponentConfig.componentname}
        columns={columns}
        filter={filter}
        exports={props.exports}
    />
}

ParentFieldSelectorGridComponent.placeHolder = placeHolderComponent;

export const ParentFieldSelectorGrid = (props) => {
    props = {...props};
    if (props.exports) {
        props.exports = props.exports.map((exporty) => {
            return {
                ...exporty,
                paramsParser: (params) => {
                    delete params.view.actions;
                    return (exporty.paramsParser || ((params) => params))(params);
                }
            };
        })
    }
    let ret = <ParentFieldSelectorGridComponent {...props} />;
    if (props.component) {
        ret = <ComponentConfig componentName={props.component}>
            {ret}
        </ComponentConfig>
    }
    if (props.parentcomponent) {
        return <ComponentConfig componentName={props.parentcomponent} componentConfigAs="parentComponentConfig">
            {ret}
        </ComponentConfig>;
    } else {
        return ret;
    }
}

ParentFieldSelectorGrid.placeHolder = placeHolderComponent;